import { VStack, Box } from '@bpba/ui-components';
import React, { FC, useLayoutEffect, useState } from 'react';
import { Footer } from '../footer/Footer';
import { Header } from '../header/Header';
import { TopComponent } from '@bpba/modules-components';
import { useUserStatus } from '../../config/authentication/useUserStatus';

type Props = {
  children: React.ReactNode;
};

export const Layout: FC<Props> = ({ children }) => {
  const [headerHeight, setHeaderHeight] = useState(80);
  const { isLoggedin } = useUserStatus();

  useLayoutEffect(() => {
    const handleResize = () => {
      setHeaderHeight(document.getElementsByTagName('header')[0].offsetHeight);
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [isLoggedin]);

  return (
    <>
      <Header />
      <Box width="100%" maxWidth="unset" px="0px" marginTop={[headerHeight]}>
        <VStack width="100%" alignItems="center">
          {children}
          <TopComponent orden={10} backgroundColor="secondary.0" />
        </VStack>
      </Box>
      <Footer />
    </>
  );
};
